export type {
	NotificationAvatarSpec,
	NotificationRowCompany,
	NotificationRowThread,
	NotificationTextInput,
} from "@productlane/lib/src/notifications/presentation"
export {
	notificationAvatar,
	notificationText,
} from "@productlane/lib/src/notifications/presentation"

export function notificationGroupPath(key: string) {
	return `/notifications/${encodeURIComponent(key)}`
}

/** Keys either side of the open one, in the order the list shows them. */
export function neighborKeys(
	keys: readonly string[],
	current: string | undefined,
): { prev: string | null; next: string | null } {
	const index = current ? keys.indexOf(current) : -1
	if (index === -1) return { prev: null, next: null }
	return {
		prev: keys[index - 1] ?? null,
		next: keys[index + 1] ?? null,
	}
}
